import { EventEmitter, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, PRIMARY_OUTLET, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Breadcrumb } from './breadcrumb.interfaces';

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
    breadcrumbChanged = new EventEmitter<Breadcrumb[]>();

    constructor(private router: Router) {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                const crumbs = this.buildBreadcrumbs(this.router.routerState.snapshot.root);
                this.breadcrumbChanged.emit(crumbs);
            });
    }

    private buildBreadcrumbs(
        route: ActivatedRouteSnapshot,
        url: string = '',
        breadcrumbs: Breadcrumb[] = []
    ): Breadcrumb[] {
        const children = route.children;

        if (children.length === 0) {
            if (breadcrumbs.length > 0) {
                breadcrumbs[breadcrumbs.length - 1].terminal = true;
            }
            return breadcrumbs;
        }

        for (const child of children) {
            if (child.outlet !== PRIMARY_OUTLET) {
                continue;
            }

            const routeURL = child.url.map(segment => segment.path).join('/');
            const nextUrl = routeURL ? `${url}/${routeURL}` : url;

            const breadcrumbLabel = child.data['breadcrumb'];
            if (breadcrumbLabel) {
                breadcrumbs.push({
                    displayName: breadcrumbLabel,
                    terminal: false,
                    url: nextUrl,
                    params: child.params
                });
            }

            return this.buildBreadcrumbs(child, nextUrl, breadcrumbs);
        }

        if (breadcrumbs.length > 0) {
            breadcrumbs[breadcrumbs.length - 1].terminal = true;
        }
        return breadcrumbs;
    }
}
